import type { Country } from '@packages/domain/models/country';
import { FETCH_COUNTRIES_SUCCESS } from 'constants/countries';
import { combineReducers } from 'redux';

type CountriesAction = {
  type: typeof FETCH_COUNTRIES_SUCCESS;
  payload: {
    entities: {
      countries: Record<string, Country>;
    };
    result: string[];
  };
};

export const byId = (
  state: Record<string, Country> = {},
  action: CountriesAction,
) => {
  switch (action.type) {
    case FETCH_COUNTRIES_SUCCESS:
      const {
        entities: { countries },
      } = action.payload;
      return countries;
    default:
      return state;
  }
};

export const ids = (state: string[] = [], action: CountriesAction) => {
  switch (action.type) {
    case FETCH_COUNTRIES_SUCCESS:
      const { result } = action.payload;
      return result;
    default:
      return state;
  }
};

const countries = combineReducers({ byId, ids });

export { countries };
